module.exports = __webpack_public_path__ + "img/venus1.ba01acbb.png";